import styled from 'styled-components';
import { CardHeaderMixin } from '../../mixins/components/CardHeaderMixin';

/**
 * @since 4.1.0
 */

var CardHeader = /*#__PURE__*/styled.h5.withConfig({
  displayName: "CardHeader",
  componentId: "c11n-8-111-1__sc-ihwhqj-0"
})(["", ""], CardHeaderMixin);
CardHeader.displayName = 'CardHeader';

/** @component */
export { CardHeader };